/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import styles from 'src/shared/app/authentication/component/base/AuthenticationBase.style';

import ResetPasswordInvalid from './ResetPasswordInvalid';
import ResetPasswordForm from './ResetPasswordForm';
import messages from 'src/shared/app/authentication/l10n/resetPasswordL10n';
import DocumentTitle from 'src/shared/app/base/component/document/DocumentTitle';
import ZIndexTopBar from 'src/shared/app/base/component/template/component/TopBar';
import TopBar from 'src/shared/app/nav/component/top-bar/TopBar';

type Props = {
  isPasswordLinkInvalid?: boolean,
};

const useStyles = createUseStyles(styles);

const ResetPasswordMainDumb = ({
  isPasswordLinkInvalid,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const elt = isPasswordLinkInvalid ? (
    <ResetPasswordInvalid />
  ) : (
    <ResetPasswordForm />
  );

  return (
    <React.Fragment>
      <DocumentTitle>{intl.formatMessage(messages.title)}</DocumentTitle>
      <section className={classes.section}>
        <ZIndexTopBar>
          <TopBar title={intl.formatMessage(messages.heading)} />
        </ZIndexTopBar>
        {elt}
      </section>
    </React.Fragment>
  );
};

export default compose(React.memo)(ResetPasswordMainDumb);
